export const FETCH_CAMPAIGNS_REQUEST = 'FETCH_CAMPAIGNS_REQUEST';
export const FETCH_CAMPAIGNS_SUCCESS = 'FETCH_CAMPAIGNS_SUCCESS';
export const UPDATE_CAMPAIGN_STATUS = 'UPDATE_CAMPAIGN_STATUS';
export const SET_CAMPAIGN_COUNT = 'SET_CAMPAIGN_COUNT';
export const ALL_CAMPAIGNS_DATA = 'ALL_CAMPAIGNS_DATA';
export const FETCH_ALL_CAMPAIGN_TEMPLATES = 'FETCH_ALL_CAMPAIGN_TEMPLATES';
